export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/3fb88be6913fbc47_LOGO.png";

export const WATERCOLOR_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/db300fb3c909f057_5428020%20-%20Copy%20%289%29.jpg";

export const IMAGES = {
  hero: "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/6b8e4eb7f60bc92d_DSC_5140.JPG.webp",
  room1: "https://images.unsplash.com/photo-1727706572437-4fcda0cbd66f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYWJpbiUyMGludGVyaW9yfGVufDB8fHx8MTc5MTk1ODcwMnww&ixlib=rb-4.1.0&q=85",
  room2: "https://images.unsplash.com/photo-1645242075656-e4e435b7a5f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYWJpbiUyMGludGVyaW9yfGVufDB8fHx8MTc5MTk1ODcwMnww&ixlib=rb-4.1.0&q=85",
  dining: "https://images.unsplash.com/photo-1779176343516-5a90f3aff418?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxyZXNvcnQlMjBkaW5pbmclMjBuYXR1cmV8ZW58MHx8fHwxNzkxOTU4NzAyfDA&ixlib=rb-4.1.0&q=85",
  nature: "https://images.unsplash.com/photo-1641589748044-3a2198e41e56?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxmb3Jlc3QlMjByZXNvcnR8ZW58MHx8fHwxNzkxOTU4NzAyfDA&ixlib=rb-4.1.0&q=85",
  gallery1: "https://images.unsplash.com/photo-1753791271869-b7c8e5736edd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxyZXNvcnQlMjBkaW5pbmclMjBuYXR1cmV8ZW58MHx8fHwxNzkxOTU4NzAyfDA&ixlib=rb-4.1.0&q=85",
  // Real photos uploaded by the owner
  deluxeRoom:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/6ebac988ea4992dd_DSC_5185.JPG.webp",
  deluxeCottage:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/71fe15c9e1635d1e_DSC_5229.JPG.webp",
  superiorRoom:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/0f448d88596f7224_DSC_5211.JPG.webp",
  familyRoom3:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/826950975e33c0be_DSC_5258.JPG.webp",
  familyRoom4:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/16d313f07a539262_DSC_5250.JPG%20%281%29.webp",
  grounds1:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/876f13499c2aaf63_DSC_5152.JPG.webp",
  grounds2:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/4ebea1ff81524319_DSC_5146.JPG.webp",
  grounds3:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/22cccd5bb2bc1a1f_DSC_5144.JPG.webp",
  grounds4:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/cb2397e0b071cdbc_DSC_5141.JPG.webp",
  grounds5:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_book-your-stay-12/artifacts/4e0adbfb5016c450_DSC_5138.JPG.webp",
};

export const ROOMS = [
  {
    id: "deluxe-room",
    name: "Deluxe Room",
    inventory: 1,
    price: "₹1,800 / night",
    description:
      "A bright, spacious room with a sitting corner — clean, quiet and close to everything in the resort.",
    image: IMAGES.deluxeRoom,
    guests: "Sleeps 2–3",
  },
  {
    id: "deluxe-cottage-room",
    name: "Deluxe Cottage Room",
    inventory: 1,
    price: "₹1,800 / night",
    description:
      "A cosy wooden cottage with warm timber walls, air conditioning and woodland charm — same great rate.",
    image: IMAGES.deluxeCottage,
    guests: "Sleeps 2–3",
  },
  {
    id: "superior-room-balcony",
    name: "Superior Room with Balcony",
    inventory: 4,
    price: "₹1,850 / night",
    description:
      "Two comfortable beds, air conditioning and a private balcony opening onto the greenery — our most loved room.",
    image: IMAGES.superiorRoom,
    guests: "Sleeps 2–3",
  },
  {
    id: "family-room-3-bed",
    name: "3 Bedded Family Room",
    inventory: 1,
    price: "₹1,900 / night",
    description:
      "A double bed plus a single, warm wooden flooring and a sitting corner — made for a small family or friends travelling together.",
    image: IMAGES.familyRoom3,
    guests: "Sleeps 3",
  },
  {
    id: "family-room-4-bed",
    name: "4 Bedded Family Room",
    inventory: 1,
    price: "₹2,200 / night",
    description:
      "Our roomiest stay — four beds in a warm wooden hall, so the whole family sleeps together under one roof.",
    image: IMAGES.familyRoom4,
    guests: "Sleeps 4",
  },
];

export const GALLERY = [
  { src: IMAGES.deluxeRoom, alt: "Deluxe Room at Resort The Forest" },
  { src: IMAGES.deluxeCottage, alt: "Deluxe Cottage Room — wooden interiors" },
  { src: IMAGES.superiorRoom, alt: "Superior Room with Balcony" },
  { src: IMAGES.familyRoom3, alt: "3 Bedded Family Room" },
  { src: IMAGES.familyRoom4, alt: "4 Bedded Family Room — wooden hall" },
  { src: IMAGES.hero, alt: "Resort exterior — cottage and gardens" },
  { src: IMAGES.grounds1, alt: "Cottages shaded by tall trees" },
  { src: IMAGES.grounds2, alt: "Wooden cottage and manicured lawns" },
  { src: IMAGES.grounds3, alt: "Cottage entrance with garden lamps" },
  { src: IMAGES.grounds4, alt: "Resort entrance and driveway" },
  { src: IMAGES.grounds5, alt: "Bamboo staircase to the balcony rooms" },
];
